const config = {
    environment: 'DEVELOPMENT',
};

export default config;